<template>
    <div class="mx-auto" v-if="visible">
      <h2 class="font-size-1 font-light text-primary-dark">{{ title }}</h2>
      <v-btn color="primary" dark dense @click="exportExcel" class="my-2" >
        <v-icon left>mdi-file-download-outline</v-icon>
        Descargar
      </v-btn>
    </div>
</template>
<script>

import axiosServices from "@/services/axiosServices";

export default {
  name: "BtnDownloadXls",
  components: {
  },
  methods: {
    exportExcel: async function () {
      let response = [];
      //let error = false;
      let params = `openWindow=true&process=${this.nameFile}`;
      if(this.headImport !== "")  {
        params = params+`&headValue=`+this.headImport;
      }
      try {
        await axiosServices.getConfiguration('download/base', false, params).then((file) => {
          response = file.aData;
        });
      } catch (e) {
        //error = e;
        //console.error(error);
      }
      return response;
    },
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    nameFile: {
      type: String,
      default: ""
    },
    headImport: {
      type: String,
      default: ""
    },
    fields: {
      type: Object,
      default: () => ([])
    },
    data: {
      type: Array,
      default: () => ([])
    },
    refComponent: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dataToExport: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

    }
  },

}
</script>

<style scoped>

</style>
